import { createStore } from 'vuex';

export default createStore({
  state: {
    bCode: '',
    sCode: 1,
    ymd: new Date(new Date().toDateString()),
    cCode: 0, //< 0...全体
  },
  getters: {},
  mutations: {
    bCode(state, code) {
      state.bCode = code;
    },
    sCode(state, code) {
      state.sCode = code;
    },
    ymd(state, date) {
      state.ymd = date;
    },
    cCode(state, code) {
      state.cCode = code;
    },
  },
  actions: {},
  modules: {},
});
